import React from 'react';
import { Check } from 'lucide-react';

function StepIndicator({ step, totalSteps, labels = [] }) {
  const steps = Array.from({ length: totalSteps }, (_, index) => index + 1);

  return (
    <div className="mb-6" role="navigation" aria-label="Progresso do assistente">
      <p className="sr-only">
        Passo {step} de {totalSteps}
        {labels[step - 1] ? `: ${labels[step - 1]}` : ''}
      </p>
      <ol className="flex items-center gap-0">
        {steps.map((stepNumber, index) => {
          const isCompleted = stepNumber < step;
          const isCurrent = stepNumber === step;
          const isLast = index === steps.length - 1;

          return (
            <li
              key={stepNumber}
              className={`flex items-center ${isLast ? '' : 'flex-1'}`}
              aria-current={isCurrent ? 'step' : undefined}
            >
              <div className="flex flex-col items-center gap-1.5 shrink-0">
                <span
                  className={`flex h-8 w-8 items-center justify-center rounded-full text-xs font-semibold transition-colors ${
                    isCompleted
                      ? 'bg-forge-600 text-white'
                      : isCurrent
                        ? 'bg-forge-600 text-white ring-4 ring-forge-100'
                        : 'border-2 border-slate-200 bg-white text-content-muted'
                  }`}
                >
                  {isCompleted ? <Check className="h-4 w-4" aria-hidden /> : stepNumber}
                </span>
                {labels[index] && (
                  <span
                    className={`hidden sm:block text-[10px] font-medium max-w-[72px] text-center leading-tight ${
                      isCurrent ? 'text-forge-700' : 'text-content-muted'
                    }`}
                  >
                    {labels[index]}
                  </span>
                )}
              </div>
              {!isLast && (
                <div
                  className={`mx-2 h-0.5 flex-1 rounded-full ${
                    isCompleted ? 'bg-forge-400' : 'bg-slate-200'
                  }`}
                  aria-hidden
                />
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
}

export default StepIndicator;
